import React, { useContext, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { NewsLetterStyle } from '../../../StyledComponents';
import ImageFileUploader from '../../Manage/ImageFileUploader';


const validationSchema = yup.object().shape({
  caption: yup.string()
    .min(3, 'Caption must be at least 3 characters')
    .max(100, 'Caption must be at most 100 characters')
    .required('Caption is required'),
  category: yup.string()
    .required('Category is required'),
  productLink1: yup.string()
    .url('Product link must be a valid URL')
    .required('Product link is required'),
  productLink2: yup.string()
    .url('Location or city link must be a valid URL')
    .required('Location or city link is required'),
});

const MaeStyleForm = ({ showState, onCancel }) => {



  const [pictures, setPictures] = useState([]);
  const [imgs, setImgs] = useState([]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);


  const { control, handleSubmit, formState: { errors } } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });


  const handleCheckboxChange = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
  };

  const handleRemoveFile = (index) => {
    const updatedImgs = imgs.filter((_, i) => i !== index);
    setImgs(updatedImgs);

    const updatedPictures = pictures.filter((_, i) => i !== index);
    setPictures(updatedPictures);
  };

  const onSubmit = (data) => {
    console.log('Form Data:', data);
    console.log('Uploaded Pictures:', pictures);

    // Create a FormData object to send
    const formData = new FormData();

    // Append form fields
    for (const key in data) {
      formData.append(key, data[key]);
    }

    // Append images
    pictures.forEach((file, index) => {
      formData.append(`images[${index}]`, file);
    });

    onCancel()

    // Send the formData object to your backend
    // Example: axios.post('your-endpoint', formData);
  };


  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>

        <NewsLetterStyle className='pt-4'>Upload Image/Video</NewsLetterStyle>
          <ImageFileUploader
           pictures={pictures}
           setPictures={setPictures}
           imgs={imgs}
           setImgs={setImgs}
           handleRemoveFile={handleRemoveFile}
          />


        <FormGroup>
          <Label for="caption">Caption</Label>
          <Controller
            name="caption"
            control={control}
            render={({ field }) => (
              <Input
                id="caption"
                type="textarea"
                placeholder='Write your detailed review'
                {...field}
                invalid={!!errors.caption}
              />
            )}
          />
          {errors.caption && <FormFeedback>{errors.caption.message}</FormFeedback>}
        </FormGroup>

        <NewsLetterStyle>Link</NewsLetterStyle>
        <FormGroup>
          <Label for="category">Category</Label>
          <Controller
            name="category"
            control={control}
            render={({ field }) => (
              <Input
                id="category"
                type="text"
                placeholder='Category'
                {...field}
                invalid={!!errors.category}
              />
            )}
          />
          {errors.category && <FormFeedback>{errors.category.message}</FormFeedback>}
        </FormGroup>

        <FormGroup>
          <Label for="productLink1">Product Link</Label>
          <Controller
            name="productLink1"
            control={control}
            render={({ field }) => (
              <Input
                id="productLink1"
                type="text"
                placeholder='Your Link'
                {...field}
                invalid={!!errors.productLink1}
              />
            )}
          />
          <em style={{color:'#FBBD34'}}>Add product link by copying from relevant product page that you are showcasng in the photo.</em>
          {errors.productLink1 && <FormFeedback>{errors.productLink1.message}</FormFeedback>}
        </FormGroup>

        <FormGroup>
          <Label for="productLink2">Product Link</Label>
          <Controller
            name="productLink2"
            control={control}
            render={({ field }) => (
              <Input
                id="productLink2"
                type="text"
                placeholder='Your Link'
                {...field}
                invalid={!!errors.productLink2}
              />
            )}
          />
          <em style={{color:'#FBBD34'}}>Tag your location or city, it would be useful for local style trends.</em>
          {errors.productLink2 && <FormFeedback>{errors.productLink2.message}</FormFeedback>}
        </FormGroup>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'none' }}>
                      <Input type="checkbox" id="terms" style={{ marginRight: '5px' }}  checked={isCheckboxChecked}
            onChange={handleCheckboxChange}/>
                      <Label className="form-check-label" for="terms">
                      I Agree that I have right to upload the image and give Mae Style permission to display it on the website.
                      </Label>
                    </div>

        {/* <div>
          <h5>Uploaded Images</h5>
          {files.map((file, index) => (
            <div key={index}>
              <img src={URL.createObjectURL(file)} alt={file.name} style={{ width: '100px', height: '100px' }} />
            </div>
          ))}
        </div> */}
            <button type='submit' className='btn my-2' style={{ backgroundColor: '#41B8E4', color: 'white' }}  disabled={!isCheckboxChecked} >Add Style</button>

        {/* <Button type="submit" color="primary" style={{color:'#41B8E4'}}>Add Style</Button> */}
      </Form>
    </>
  );
};

export default MaeStyleForm;
